import { PackageVariantClosedRemoveIcon } from './PackageVariantClosedRemoveIcon';

/**
 * author: Ferenc Szabo
 * id 425F62CE-0308-47E5-9825-CEE711EE34B2
 * name package-variant-closed-remove
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/package-variant-closed-remove.svg
 * tags
 */
export const BoxVariantClosedRemoveIcon = PackageVariantClosedRemoveIcon;
export default BoxVariantClosedRemoveIcon